module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.12114db3.svg";